/**
 * SHX footer accordion — collapses footer link menus into accordions on mobile
 * (Rosental/Stretch pattern), as a runtime enhancement over Shrine's untouched
 * footer markup. Desktop keeps the normal open columns; without JS the footer
 * renders exactly as stock.
 */

const DESKTOP = window.matchMedia('(min-width: 990px)');
const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
let uid = 0;

function initFooterAccordions() {
  document.querySelectorAll('.footer-block--menu').forEach((block) => {
    if (block.dataset.shxFacc) return;
    const heading = block.querySelector('.footer-block__heading');
    const list = block.querySelector('.footer-block__details-content');
    if (!heading || !list) return;
    block.dataset.shxFacc = 'true';
    block.classList.add('shx-facc');

    uid += 1;
    const panelId = `ShxFacc-${uid}`;

    // Heading becomes a real button (proper accordion semantics).
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'shx-facc__btn';
    button.setAttribute('aria-controls', panelId);
    while (heading.firstChild) button.appendChild(heading.firstChild);
    const chevron = document.createElement('span');
    chevron.className = 'shx-facc__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    button.appendChild(chevron);
    heading.appendChild(button);

    // Panel wrapper enables the animated grid-rows collapse.
    const panel = document.createElement('div');
    panel.className = 'shx-facc__panel';
    panel.id = panelId;
    const innerWrap = document.createElement('div');
    innerWrap.className = 'shx-facc__inner';
    list.parentNode.insertBefore(panel, list);
    innerWrap.appendChild(list);
    panel.appendChild(innerWrap);

    const sync = () => {
      if (DESKTOP.matches) {
        button.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
      } else {
        button.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
      }
    };
    sync();
    DESKTOP.addEventListener('change', sync);

    button.addEventListener('click', () => {
      if (DESKTOP.matches) return;
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.classList.toggle('is-open', !open);
    });
  });
}

initFooterAccordions();
document.addEventListener('shopify:section:load', initFooterAccordions);
